
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class SpecSheetGrid extends Serenity.EntityGrid<SpecSheetRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.SpecSheet'; }
        protected getDialogType() { return SpecSheetDialog; }
        protected getIdProperty() { return SpecSheetRow.idProperty; }
        protected getInsertPermission() { return SpecSheetRow.insertPermission; }
        protected getLocalTextPrefix() { return SpecSheetRow.localTextPrefix; }
        protected getService() { return SpecSheetService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        } 
        protected addButtonClick() {

            let now = new Date(); 
            var voucherNo = FormatHelper.GetVoucherNo(103);
            var userDefinition = Q.Authorization.userDefinition;
            this.editItem(<SpecSheetRow>{
                VoucherNo: voucherNo, 
                VoucherTypeId: 103,
                CompanyId:userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                TransDate: now.toDateString()
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getButtons(): Serenity.ToolButton[] {

            // call base method to get list of buttons
            var buttons = super.getButtons();

            // add our import button
            buttons.push({
                title: 'Import',
                cssClass: 'import-xlsx-button',
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new SpecSheetImportDialog();
                    dialog.element.on('dialogclose', () => {
                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });

            return buttons;
        }   

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}